import Vue from 'vue'
import store from '@/store'

export default async (data) => {
  const res = await Vue.axios.post('/auth/users', {
    fullname: data.fullName,
    password: data.password,
    verify_password: data.password,
    email: data.email,
    phone: data.phoneNumber,
    formatted_phone: data.formatted_phone
  })
  store.dispatch('register', res)
}



// WEBPACK FOOTER //
// ./src/services/auth/register.js